import { Remarks } from "pages";

const remark_routes = ({ is_admin = false, can_manage_remarks = false } = {}) => {
  const routes = [
    {
      path: "/remarks",
      component: Remarks.List,
    },
    {
      path: "/remarks/:id",
      component: Remarks.Edit,
    },
  ];

  if (is_admin || can_manage_remarks) {
    routes.splice(1, 0, {
      path: "/remarks/new",
      component: Remarks.New,
    });
  }

  return routes;
};

export default remark_routes;
